import { EditButton, TopToolbar } from "react-admin";

export const EventShowToolbar = () => (
  <TopToolbar>
    <EditButton />
  </TopToolbar>
);
